export class JsonShapeUrls {
    public zip: string;
    public city: string;
    public county: string;
    public fhd: string;
    public shd: string;
    public ssd: string;
    public idhs: string;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/json-shape-urls.ts